import { usePageScrollLock } from "@/hooks";
import { Stack } from "@mui/material";
import { FC } from "react";
import { Feedbacks } from "../feedbacks";
import { SupportChat } from "../support-chat";

const SupportPage: FC = () => {
  usePageScrollLock();

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        justifyContent: "space-between",
        display: "flex",
        flex: 1,
        marginBottom: 2,
        maxHeight: "calc(100vh - 84px)",
      }}
    >
      <Stack
        width={"100%"}
        maxWidth={"400px"}
        height={"100%"}
        padding={2}
        border={"1px solid #262525"}
        borderRadius={2}
      >
        <Feedbacks />
      </Stack>
      <Stack width={"100%"} border={"1px solid #262525"} borderRadius={2}>
        <SupportChat />
      </Stack>
    </Stack>
  );
};

export { SupportPage };
